import { render, staticRenderFns } from "./DialogChooser.vue?vue&type=template&id=396b3a9a&scoped=true&"
import script from "./DialogChooser.vue?vue&type=script&lang=js&"
export * from "./DialogChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b3a9a",
  null
  
)

export default component.exports